//登录
export const USER_LOGIN = "user/login"
export const USER_LOGOUT = "user/logout"

//用户信息
export const USER_PROFILE = "user/profile"
export const USER_UPDATE_PASSWORD = "user/update/password"
export const USER_UPDATE_MOBILE = "user/update/mobile"
export const USER_UPDATE_PORTRAIT = "user/update/portrait"





// WEBPACK FOOTER //
// ./src/api/user.js